import LazyLoadComponent from 'app/developer-v3/components/LazyLoadComponent';

// Lazily load this module since it is imported but not rendered on the
// Developer Platform dashboard page.
const LazyLoadSidebarContainer = LazyLoadComponent({
  loader: () =>
    import(
      /* webpackChunkName: 'app-developer-v3-components-Sidebar-Container' */
      './Container'
    ),
});

export default LazyLoadSidebarContainer;
